import React, { useContext, useState } from "react";

const StoreCountryContext = React.createContext();

export function useStoreCountry() {
    return useContext(StoreCountryContext);
}

export function StoreCountryProvider({ children }) {
    const [store, setStore] = useState("");
    return (
        <StoreCountryContext.Provider value={{ store, setStore }}>
            {children}
        </StoreCountryContext.Provider>
    );
}